import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class HistoryListViewProvider {
	private readonly GAP_PX = 56;
	private readonly PANEL_HEADER = 48;

	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const modalContent =
			elemRef.nativeElement.querySelector('.app-modal-content');

		const historyList = document.querySelector(
			'.app-history-list'
		) as HTMLElement | null;

		const historyListHeight =
			modalContent.offsetHeight - this.GAP_PX - this.PANEL_HEADER;

		renderer.setStyle(
			historyList,
			'--max-height-histories',
			`${historyListHeight}px`,
			RendererStyleFlags2.DashCase
		);
	}
}
